import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex gap-12",
    "data-swiper-navigation": ""
};
import { onMounted, ref } from 'vue';
import SwiperNavArrow from '@atoms/SwiperNavArrow.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SwiperNavigation',
    props: {
        carouselTitle: {
            type: String,
            required: true,
        },
    },
    setup(__props) {
        const swiperEl = ref(null);
        const numberOfSlides = ref(null);
        const props = __props;
        onMounted(() => {
            const swiperContainer = document.querySelector(`.swiper-container[data-carousel="${props.carouselTitle}"]`);
            if (swiperContainer && props.carouselTitle) {
                swiperEl.value = swiperContainer.swiper;
                if (swiperEl.value) {
                    swiperEl.value.on('slideChange', () => {
                        hasNextSlide.value = swiperEl.value.isEnd !== true;
                        hasPreviousSlide.value = swiperEl.value.isBeginning !== true;
                        // Update the number of slides
                        numberOfSlides.value = swiperEl.value.slides
                            ? swiperEl.value.slides.length
                            : 0;
                    });
                }
            }
        });
        const hasNextSlide = ref(true);
        const hasPreviousSlide = ref(false);
        const slideNext = () => {
            if (swiperEl.value && hasNextSlide.value) {
                swiperEl.value.slideNext();
            }
        };
        const slidePrevious = () => {
            if (swiperEl.value && hasPreviousSlide.value) {
                swiperEl.value.slidePrev();
            }
        };
        return (_ctx, _cache) => {
            return (swiperEl.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(SwiperNavArrow, {
                        active: hasPreviousSlide.value,
                        direction: "previous",
                        onClick: slidePrevious
                    }, null, 8, ["active"]),
                    _createVNode(SwiperNavArrow, {
                        active: hasNextSlide.value,
                        direction: "next",
                        onClick: slideNext
                    }, null, 8, ["active"])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
